module.exports = __webpack_public_path__ + "static/media/product-01.6e5635dd.jpg";